import React, { FC, ReactNode } from 'react'

// @ts-ignore
import styles from './Label.scss'

/**
 * 責務: ラベルの表示
 * @param { ReactNode } children labelに含めるchildren
 * @returns { JSX.Element } ラベルコンポーネントを返す
 */

export type LabelProps = JSX.IntrinsicElements['label'] & {
  children: ReactNode
}

export const Label: FC<LabelProps> = ({
  children,
  ...rest
}) => {
  return (
    <label className={`${styles.label}`} {...rest}>
      {children}
    </label>
  )
}

/**
 * 責務: 必須文字の表示
 * @param { HTMLAttributes<HTMLSpanElement> } props spanタグのprops
 * @returns
 */

export type RequiredProps = JSX.IntrinsicElements['span'] & {}
export const Required: FC<RequiredProps> = (props) => <span className={`${styles.required}`} {...props}>必須</span>
